import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { DividerModule } from 'primeng/divider';
import { AuthService } from '../../../../../core/services/auth/auth.service';
import { Router } from '@angular/router';
import { HasActionDirective } from '../../../../directives/has-action.directive';
import { ACTIONS } from '../../../../../core/constants/actions.constants';
import { AuthUser } from '../../../../../core/services/auth/types/auth-user.type';

@Component({
  selector: 'app-dropdown-profile',
  imports: [CommonModule, PopoverModule, DividerModule, HasActionDirective],
  templateUrl: './dropdown-profile.html',
  styleUrl: './dropdown-profile.scss'
})
export class DropdownProfile {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  // Hacer ACTIONS disponible en el template
  readonly ACTIONS = ACTIONS;

  currentUser = computed(() => this.authService.currentUser());

  userEmail = computed(() => {
    const user = this.currentUser();
    return user?.email || 'usuario@example.com';
  });

  userName = computed(() => {
    const user = this.currentUser();
    return user?.firstName + ' ' + user?.lastName || user?.email?.split('@')[0] || 'Usuario';
  });

  userInitials = computed(() => {
    const user = this.currentUser();
    return this.getUserInitials(user);
  });

  private getUserInitials(user: AuthUser | null): string {
    if (!user) {
      return 'U';
    }

    const firstName = user.firstName?.trim() || '';
    const lastName = user.lastName?.trim() || '';

    if (firstName && lastName) {
      return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    } else if (firstName) {
      return firstName.charAt(0).toUpperCase();
    } else if (lastName) {
      return lastName.charAt(0).toUpperCase();
    } else if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }

    return 'U';
  }

  // items array removido - ahora usamos HTML estático con directiva *appHasAction

  logout(): void {
      this.authService.logout().subscribe();
  }

  goToSettings(): void {
    this.router.navigate(['/crm/settings/']);
  }

  goToProfile(): void {
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
